<template>
	<a-layout id="components-layout-demo-top-side-2" style="height: 100%;">
		<a-layout-header class="header">
			<div style="height: 100%;display: flex;align-items: flex-end;">
				<div class="title">
					<a-button type="primary" shape="circle" icon="appstore" @click="showDrawerMainMenu" />
					<span style="margin-left: 4px;">秦皇岛求仙入海处</span>
				</div>
				<a-tabs v-model="selectTabs" hide-add type="editable-card" @edit="tabsEdit" @change="tabsClick">
					<a-tab-pane key="0" tab="主页" :closable="false"></a-tab-pane>
					<a-tab-pane v-for="(item,index) in tabsList" :key="item.dutyId" :tab="item.dutyName" ></a-tab-pane>
				</a-tabs>
	
				
			</div>
		

			<a-popover placement="bottomRight">
				<template slot="content">
					<div>
						<span style="font-size: 20px;color: #1786ce;font-weight: 550;">{{staff.staffAccount}}</span>
						<span>，欢迎使用本系统！</span>
					</div>
					<div>
						上次登录时间：2025-03-10 09:50:14
					</div>
					<div style="text-align: center;">
						<a-button type="link" >修改密码</a-button>
						<a-divider type="vertical" />
						<a-button type="link" @click="outLogin">退出登录</a-button>
					</div>
				</template>
			
				<a-button type="link" ghost>{{staff.staffAccount}}</a-button>
			</a-popover>


			<a-drawer title="主菜单" placement="left" :closable="true" :visible="mainMenuVisible" @close="onCloseMainMenu">
				<div class="first-menu-item" :class="selectFirstMenu.dutyId==item.dutyId ? 'first-menu-item-select':''" v-for="(item, index) in firstMenuData" :key="index" @click="clickFirstMenuItem(item)">
					<i :class="item.icon"></i>{{item.dutyName}}
				</div>
			</a-drawer>

		</a-layout-header>
		<a-layout>
			<a-layout-sider width="200" style="background: #fff;overflow-y:auto;overflow-x: hidden;">
				<div class="qa-menu-title">{{selectFirstMenu.dutyName}}</div>
				<a-menu mode="inline"  :style="{ height: 'calc(100% - 53px)', borderRight: 0 }">
					<template v-for="(item,index) in secondMenuData">
						<a-menu-item v-if="item.lowerSum == 0" :key="index" @click="jump(item)">
							<i class="qa-menu-i" :class="item.icon"></i>{{item.dutyName}}
						</a-menu-item>
						<!-- <sub-menu v-else :key="item.key" :menu-info="item" /> -->
						<a-sub-menu v-if="item.lowerSum > 0" :key="index" >
							<span slot="title">
								<i class="qa-menu-i" :class="item.icon"></i>{{item.dutyName}}
							</span>
							<!-- {{item.child[0].dutyName}} -->
							<template v-for="(items,indexs) in item.child">
								<a-menu-item   :key="indexs" @click="jump(items)">
									<i class="qa-menu-i" :class="items.icon"></i>{{items.dutyName}}
								</a-menu-item>
							</template>
						</a-sub-menu>
					</template>
					
				</a-menu>
			</a-layout-sider>
			<a-layout>
				<a-layout-content style="background:#f0f2f5; margin: 0 10px; minHeight:280px">
				<!-- <a-layout-content style="background:#eef7ff; margin: 0 10px; minHeight:280px"> -->
					<a-config-provider :locale="zh_CN">
						<router-view></router-view>
						
					</a-config-provider>
				</a-layout-content>
			</a-layout>
		</a-layout>
	</a-layout>

</template>
<script>
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
	export default {
		data() {
			return {
				staff: {
					staffAccount: window.sessionStorage.getItem('staffAccount')
				},
				zh_CN: zh_CN,
				collapsed: false,
				mainMenuVisible: false,
				firstMenuData: [],
				selectFirstMenu: {
					dutyName: '主页'
				},
				secondMenuData: [],
				tabsList: [],
				selectTabs: '',
			};
		},
		methods: {
			//标签页点击事件
			tabsEdit(targetKey, action){
				if(action == 'remove'){
					for(let i=0; i<this.tabsList.length; i++) {
						if(this.tabsList[i].dutyId == targetKey) {
							this.tabsList.splice(i, 1)
						}
					}
				}
			},
			tabsClick(activeKey){
				if(activeKey == 0) {
					this.$router.push('/Home')
				}
				for(let i=0; i<this.tabsList.length; i++) {
					if(this.tabsList[i].dutyId == activeKey){
						window.sessionStorage.setItem('selectSecondMenu', this.tabsList[i].dutyName)
						this.$router.push(this.tabsList[i].dutyUrl)
					}
				}
			},
			outLogin() {
				this.$router.push('/Login')
			},
			showDrawerMainMenu() {
				this.mainMenuVisible = true
			},
			onCloseMainMenu() {
				this.mainMenuVisible = false
			},
			async apiDutyList(parentId){
				//登录逻辑
				const {data: res} = await this.$http.post(this.navigation.apiDutyList, {parentId: parentId});
				if(res.code == 200){
					let datas = res.data
					if(parentId == 0) this.firstMenuData = datas
					if(parentId > 0){
						for(let i=0; i<datas.length; i++){
							if(datas[i].lowerSum > 0){
								datas[i].child = []
								this.thirdApiDutyList(datas[i].dutyId).then(ress=>{
									datas[i]['child'] = ress
								})
							}
						}
						this.secondMenuData = datas
					}
					
				}else{
					this.$message.error(res.msg)
				}
				this.$forceUpdate()
			},
			thirdApiDutyList(parentId){
				return new Promise((resolve, reject) => {
					this.$http.post(this.navigation.apiDutyList, {parentId: parentId}).then((res)=>{
						resolve(res.data.data)
					})
				})
			},
			//关闭主菜单弹窗
			clickFirstMenuItem(item){
				window.sessionStorage.setItem('selectFirstMenu', item.dutyName)
				this.selectFirstMenu = item
				this.apiDutyList(item.dutyId)
				this.mainMenuVisible = false
				
			},
			jump(e) {
				window.sessionStorage.setItem('selectSecondMenu', e.dutyName)
				this.$router.push(e.dutyUrl)
				for(let i=0; i<this.tabsList.length; i++) {
					if(this.tabsList[i].dutyId == e.dutyId){
						return
					}
				}
				this.tabsList.push(e)
				this.selectTabs = e.dutyId
			},

		},
		created() {
			this.apiDutyList(0)
		}
	};
</script>

<style lang="less">
	.main-info {
		background-color: #fff;
	}
	.ant-tabs-bar{
		margin: 0 !important;
		border-bottom: none !important;
	}
	.ant-tabs-tab-active{
		background-color: #f0f2f5 !important;
	}
	#components-layout-demo-top-side-2 .title {
		padding-left: 10px;
		width: 200px;
		color: #fff;
		float: left;
	}

	.ant-layout-header {
		padding: 0 !important;
		display: flex;
		justify-content: space-between;
		background-color: #1786ce !important;
		align-items: center;
		// background-image: linear-gradient(179deg,#E9FBFF 0%,#F3F5FF 100%) !important;
	}

	::-webkit-scrollbar {
		width: 4px;
		height: 8px;
	}

	::-webkit-scrollbar-thumb {
		background-color: #d9d9d9;
		border-radius: 6px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	}

	::-webkit-scrollbar-track {
		background: #e8e8e8;
	}
	.ant-time-picker{
		width: 100% !important;
	}
	.qa-menu-title{
		height: 53px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #e6f7ff;
		
	}
	.first-menu-item{
		border-radius: 10px;
		padding: 6px;
		margin-bottom: 4px;
	}
	.first-menu-item i{
		margin-right: 10px;
	}
	.qa-menu-i{
		margin-right: 10px;
	}
	.first-menu-item:hover{
		cursor:pointer;
		background-color: #f0f2f5;
	}
	.first-menu-item-select{
		background-color: #e6f7ff;
		color: #1890ff;
		margin-bottom: 4px;
	}
	.first-menu-item-select:hover{
		background-color: #e6f7ff;
		color: #1890ff;
	}
	.ant-collapse-header{
		background-color: #fff;
	}
	.ant-collapse-header i{
		color: #1890ff !important;
	}
	.ant-collapse > .ant-collapse-item:last-child{
		border-radius: 0 !important;
	}
	.qinang-card{
		margin-top: 10px;
		// padding: 0;
		background-color: #fff;
		border: 1px solid #e8e8e8;
	}
	.qinang-card-2{
		padding: 0 16px;
		background-color: #fff;
		border: 1px solid #e8e8e8;
	}
	.ant-table-thead > tr > th{
		padding: 10px 6px !important;
	}
	.ant-table-tbody > tr > td{
		padding: 10px 6px !important;
	}
	.qinang-button-margin{
		margin-right: 8px;
	}
	.qinang-margin-top-12 {
		margin-top: 12px;
	}
	.qinang-search-row{
		display: flex;
		justify-content: space-between;
	}
	.qinang-search-col-3{
		width: 30%;
		display: flex;
		align-items: center;
	}
	.qinang-search-col-3 .ant-select {
		width: calc(100% - 90px);
	}
	.qinang-search-col-3 .ant-input {
		width: calc(100% - 90px);
	}
	.qinang-search-col-title{
		width: 90px;
		text-align: end;
	}
	.qinang-search-time-picker-2 {
		width: calc((100% - 110px) / 2);
	}
	.qinang-search-time-picker-2 .ant-input {
		width: 100% !important;
	}
	
	//弹窗样式-------------------------------------------------------------------------开始
	//全屏
	.qa-modal .ant-modal{
		top: 0 !important;
		height: 100%;
		padding: 0;
	}
	.qa-modal .ant-modal-content{
		height: 100%;
		background-color: #f5f5f5;
		
	}
	.qa-modal .ant-modal-body{
		display: flex;
		justify-content: center;
	}
	
	.qa-modal .ant-form{
		padding: 20px 40px 20px 20px;
		max-height: calc(100vh - 104px);
		overflow-y:scroll;
	}
	
	.qa-modal .ant-form-item-label{
		width: 120px;
	}
	.qa-modal .ant-modal-header{
		background-image: url(../assets/images/title-bg.png);
		background-size: 100% 100%;
	}
	//非全屏	
	.qa-modal-half .ant-form-item-label{
		width: 120px;
	}
	.qa-modal-half .ant-modal-header{
		background-image: url(../assets/images/title-bg.png);
		background-size: 100% 100%;
	}
	//弹窗样式-------------------------------------------------------------------------结束
	//提交表单样式-------------------------------------------------------------------------开始
	.qa-table-item-1{
		display: flex;
	}
	.qa-table-item-1 .ant-form-item{
		width: 100%;
	}
	.qa-table-item-1 .ant-col-14{
		width: calc(100% - 120px);
	}
	.qa-table-item-1-remarks{
		display: flex;
	}
	.qa-table-item-1-remarks .ant-form-item{
		width: 33.33%;
	}
	.qa-table-item-1-remarks-right{
		display: flex;
		align-items: center;
		font-size: 14px;
		margin-bottom: 24px;
		color: #ff9800;
	}
	
	.qa-table-item-2{
		display: flex;
	}
	.qa-table-item-2 .ant-form-item:first-of-type{
		width: calc(calc(100% - 100px) * 0.666 + 50px);
		margin-right: 50px;
	}
	.qa-table-item-2 .ant-col-14{
		width: calc(100% - 120px);
	}
	.qa-table-item-2 .ant-form-item{
		width: calc(calc(100% - 100px) * 0.333);
	}
	.qa-table-item-2 .ant-col-14{
		width: calc(100% - 120px);
	}
	.qa-table-item-3{
		display: flex;
	}
	.qa-table-item-3 .ant-form-item{
		width: 33.33%;
		margin-right: 50px;
	}
	.qa-table-item-3 .ant-form-item:last-child{
		margin-right: 0px;
	}
	.qa-table-item-3 .ant-col-14{
		width: calc(100% - 120px);
	}
	//提交表单样式-------------------------------------------------------------------------结束
	//分割线
	.ant-divider-horizontal.ant-divider-with-text-center::before{
		border-top: 1px solid #1890ff;
	}
	.ant-divider-horizontal.ant-divider-with-text-center::after{
		border-top: 1px solid #1890ff;
	}
	.ant-divider-horizontal.ant-divider-with-text-center{
		color: #1890ff;
	}
	.qa-card-title{
		color: #1786ce;
		height: 46px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
